import styled from 'styled-components'
import Button from 'components/Button'
import { FONT } from 'theme/font'
import { Form as AntdForm } from 'antd'
import { COLORS } from 'theme'
import Input from '../../../components/Form/Input'
import Select from 'components/Select2'
import { Radio } from 'antd'

const TYPOGRAPHY = {
  // Font sizes
  HEADING_XL: '24px', // Main page headings
  HEADING_L: '20px', // Section headings
  HEADING_M: '18px', // Subsection headings
  HEADING_S: '16px', // Component headings
  BODY_L: '16px', // Large body text
  BODY_M: '14px', // Default body text
  BODY_S: '13px', // Small body text
  CAPTION: '12px', // Captions, labels
  TINY: '11px', // Very small text

  // Font weights
  WEIGHT_LIGHT: '300',
  WEIGHT_REGULAR: '400',
  WEIGHT_MEDIUM: '500',
  WEIGHT_SEMIBOLD: '600',
  WEIGHT_BOLD: '700',

  // Line heights
  LINE_HEIGHT_TIGHT: '1.2',
  LINE_HEIGHT_NORMAL: '1.4',
  LINE_HEIGHT_RELAXED: '1.6',
}

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding: 0 24px;
  gap: 16px;
`

export const SelectStudentsHeading = styled.div`
  font-family: ${FONT.FONT_FAMILY};
  font-size: ${FONT.F_SM};
  font-weight: ${FONT.FW_500};
  color: ${COLORS.GREY_S_50};
  margin-bottom: 12px;
  margin-top: 24px;
`

export const SelectStudentsNote = styled.div`
  font-family: ${FONT.FONT_FAMILY};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_40};
  margin-bottom: 0px;
`
export const StreamRadioGroup = styled(Radio.Group)`
  display: flex;
  gap: 5px;

  .ant-radio-wrapper {
    border: 1px solid ${props => (props.error ? COLORS.RED_T_50 : '#D0D5DD')} !important;
    border-radius: 8px;
    padding: 8px 9px;
    margin-right: 0;
    transition: all 0.3s ease;

    &:hover {
      border-color: ${props =>
    props.error ? COLORS.RED_T_50 : COLORS.BLUE_100};
    }

    &.ant-radio-wrapper-checked {
      border-color: ${props =>
    props.error ? COLORS.RED_T_50 : COLORS.BLUE_100};
    }
  }
`

export const QualificationButton = styled.button`
  background: ${props => (props.$isSelected ? COLORS.BLUE_100 : 'transparent')};
  color: ${props => (props.$isSelected ? COLORS.WHITE : COLORS.BLUE_100)};
  border: 1px solid ${COLORS.BLUE_100};
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  &:hover {
    background: ${props =>
    props.$isSelected ? COLORS.BLUE_T_25 : COLORS.BLUE_T_95};
    border-color: ${COLORS.BLUE_T_25};
  }

  &:active {
    background: ${props =>
    props.$isSelected ? COLORS.BLUE_S_30 : COLORS.BLUE_T_80};
    border-color: ${COLORS.BLUE_S_30};
  }
`

export const QualificationButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  margin: 24px 0;
`

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.$marginBottom ? props.$marginBottom : '16px'} !important;
  ${props => props.$width && `width: ${props.$width}`}// margin-top: ${props =>
    props.$marginTop ? props.$marginTop : '8px'} !important;
`

export const AssessmentContainer = styled.div`
  padding: 40px 0;
`

export const Title = styled.div`
  font-size: ${TYPOGRAPHY.HEADING_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_LIGHT};
  color: ${COLORS.GREY_P_100};
  margin-bottom: 16px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  margin: 16px 0; // Changed from 32px 0 to 16px 0
`

export const SaveButton = styled(Button.Primary)`
  padding: 10px 16px;
  height: 47px;
  font-size: ${FONT.F_SM};
  background: #444ce7 !important;
  border-radius: 8px;
  min-width: 80px;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer !important;
  border: none;
  color: white;
  opacity: 1 !important;

  &:hover {
    background: #444ce7 !important;
    opacity: 0.9 !important;
  }

  &:disabled {
    background: #444ce7 !important;
    cursor: pointer !important;
    opacity: 1 !important;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: ${FONT.F_SM};
  color: #101828;
  outline: none;
  height: 44px;

  &::placeholder {
    color: #667085;
  }

  &:focus {
    border-color: #444ce7;
    box-shadow: 0 0 0 1px #444ce7;
  }
`

export const SearchSection = styled.div`
  margin-bottom: 0px;
`

export const SavedAssessmentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 24px; // Changed from 16px to 12px
  border-radius: 8px;
  margin-bottom: 24px; // Changed from 32px to 24px
`

export const AssessmentName = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: ${TYPOGRAPHY.BODY_L};
  color: #3249d7;
  font-weight: ${TYPOGRAPHY.WEIGHT_BOLD};
  margin-left: 12px;
  min-width: 300px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const EditButton = styled(Button.Secondary)`
  height: 36px;
  padding: 8px 14px;
  font-size: ${FONT.F_SM};
  min-width: 67px;
`

export const DeleteButton = styled(Button.Secondary)`
  height: 36px;
  padding: 8px 14px;
  font-size: ${FONT.F_SM};
  color: #f04438;
  border-color: #fda29b;
  min-width: 67px;

  &:hover {
    background: #fee4e2;
    border-color: #fda29b;
  }
`
export const Grid = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  max-width: 800px;

  .ant-form-item {
    margin-bottom: 0;
    flex: 0 1 auto;
    min-width: 180px;
  }

  #start_time,
  #end_time {
    width: 180px;
  }

  .ant-picker {
    width: 200px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid ${COLORS.BORDER};
    font-size: 13px;
    padding: 0 12px;

    &:hover,
    &:focus {
      border-color: ${COLORS.PRIMARY};
    }

    .ant-picker-input {
      input {
        font-size: 13px;
        padding: 0 8px;
        color: ${COLORS.TEXT_PRIMARY};
      }
    }
  }

  .rc-time-picker {
    width: 180px;

    input {
      height: 36px;
      border-radius: 6px;
      border: 1px solid ${COLORS.BORDER};
      font-size: 13px;
      padding: 0 8px;

      &:hover,
      &:focus {
        border-color: ${COLORS.PRIMARY};
      }
    }
  }

  .ant-picker-time-panel-column {
    li {
      padding: 2px 0;
      height: 24px;
      font-size: 13px;
      color: ${COLORS.TEXT_PRIMARY};

      &:hover {
        background: ${COLORS.BLUE_T_95};
      }
    }
  }

  .ant-picker-time-panel {
    width: 100px;
    background: ${COLORS.WHITE};
  }
`

export const AssessmentLinkSection = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
`

export const AssessmentLinkInput = styled(Input)`
  margin-top: 8px;
  width: 100%;
  transition: all 0.3s ease;

  // Error state styles
  &.error {
    border: 0.5px solid ${COLORS.RED_T_50};
    box-shadow: 0 0 0 1px ${COLORS.RED_T_50};
  }

  // Normal state
  &:not(.error) {
    border: 1px solid #d0d5dd;

    &:hover {
      border-color: #444ce7;
    }

    &:focus {
      border-color: #444ce7;
      box-shadow: 0 0 0 1px #444ce7;
    }
  }
`

export const UploadSummary = styled.div`
  background-color: #f0f9ff;
  // border-left: 4px solid #0369a1;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #1e3a8a;
  display: flex;
  align-items: center;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    background-color: #e0f2fe;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`
export const DescriptionHeader = styled.div`
  font-family: ${FONT.FONT_FAMILY};
  font-size: ${TYPOGRAPHY.BODY_M};
  color: ${COLORS.GREY_T_40};
  font-weight: ${TYPOGRAPHY.WEIGHT_REGULAR};
  margin-bottom: 8px;
  margin-top: 16px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const DescriptionText = styled.div`
  font-family: ${FONT.FONT_FAMILY};
  font-size: ${TYPOGRAPHY.BODY_M};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_RELAXED};
  color: ${COLORS.TEXT_PRIMARY};

  .parameter-item {
    margin-bottom: 4px;
    font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
    font-size: ${TYPOGRAPHY.BODY_M};
  }

  .parameter-label {
    font-weight: ${TYPOGRAPHY.WEIGHT_BOLD};
    font-size: ${TYPOGRAPHY.BODY_M};
  }

  .parameter-text {
    font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
    color: ${COLORS.GREY_T_30};
    font-size: ${TYPOGRAPHY.BODY_S};
  }
`

export const SelectionRow = styled.div`
  gap: 24px;
  margin-bottom: 24px;
`

export const SelectionColumn = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  min-width: 440px;
  width: fit-content;
  margin-bottom: 32px;
`
export const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 450px;
  }
`

export const StyledSearchSection = styled(SearchSection)`
  width: 550px;
`

export const StyledSearchInput = styled(SearchInput)`
  width: 81%;
`

export const CheckboxGridContainer = styled.div`
  margin-top: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
  ${props =>
    props.error &&
    `
    border-color: ${COLORS.RED_T_50};
    box-shadow: 0 0 0 1px ${COLORS.RED_T_50};
  `}
`

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
  margin-top: 12px;
`

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;

  .ant-checkbox-wrapper {
    font-size: 14px;
    color: #333;

    &:hover {
      color: #1890ff;
    }
  }

  .ant-checkbox {
    margin-right: 8px;
  }
`

export const SelectAllContainer = styled.div`
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;

  .ant-checkbox-wrapper {
    font-weight: 500;
    color: #1890ff;
  }
`
export const multiSelectRadioStyles = `
  .multi-select-radio .ant-radio-wrapper {
    cursor: pointer;
  }
  
  .multi-select-radio .ant-radio {
    cursor: pointer;
  }
  
  .multi-select-radio .ant-radio-inner {
    border-radius: 2px; /* Make it look slightly more like a checkbox if desired */
  }
  
  .multi-select-radio .ant-radio-checked .ant-radio-inner {
    background-color: #1890ff;
    border-color: #1890ff;
  }
  
  .multi-select-radio .ant-radio-checked .ant-radio-inner::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 10px;
    border: none;
    width: auto;
    height: auto;
    background: transparent;
  }
`

export const DifficultyContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: #fafafa;
`

export const DifficultyTitle = styled.h3`
  font-size: ${TYPOGRAPHY.HEADING_M};
  margin-bottom: 20px;
  color: #333;
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const DifficultyInputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
`

export const DifficultyInputWrapper = styled.div`
  flex: 1 1 30%;
  display: flex;
  flex-direction: column;
  min-width: 180px;
`

export const DifficultyLabel = styled.label`
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  margin-bottom: 8px;
  font-size: ${TYPOGRAPHY.BODY_M};
  color: #555;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const DifficultySubLabel = styled.span`
  font-weight: ${TYPOGRAPHY.WEIGHT_REGULAR};
  color: #888;
  font-size: ${TYPOGRAPHY.BODY_S};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const DifficultyInput = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`

export const PrepareButton = styled.button`
  margin-top: 20px;
  padding: 12px 20px;
  border-radius: 6px;
  background-color: #1976d2;
  color: #fff;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1565c0;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`

export const AptitudeTypeCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    3,
    minmax(140px, 160px)
  ); // Further reduced from 180px-200px
  gap: 8px; // Reduced from 12px
  margin-bottom: 16px; // Reduced from 20px
  justify-content: start;
  max-width: 520px; // Reduced from 640px to make container smaller
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    max-width: 100%;
  }
`

export const AptitudeTypeCard = styled.div`
  position: relative;
  padding: 8px; // Reduced from 10px
  border: 1px solid ${props => (props.isSelected ? '#A9A9A9' : '#A9A9A9')}; // Keep as is since it's gray
  border-radius: 8px; // Reduced from 6px
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => (props.isSelected ? '#f8fafc' : '#ffffff')};
  min-height: 50px; // Reduced from 70px
  max-width: 160px; // Reduced from 200px
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); // Added subtle shadow for consistency

  &:hover {
    border-color: ${props => (props.isSelected ? '#808080' : '#808080')};
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); // Enhanced shadow on hover
  }

  ${props =>
    props.topicCount > 0 &&
    `
    &::before {
      content: '${props.topicCount}';
      position: absolute;
      top: 4px; // Reduced from 6px
      right: ${props.isSelected ? '4px' : '4px'}; // Adjusted for smaller card
      width: 16px; // Reduced from 18px
      height: 16px; // Reduced from 18px
      background: #444CE7; // Changed from #1890ff to #444CE7
      color: white;
      border-radius: 50%;
      font-size: 9px; // Reduced from 10px
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`

export const AptitudeTypeTitle = styled.h3`
  margin: 0;
  font-size: ${TYPOGRAPHY.BODY_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: ${props => (props.isSelected ? '#1f2937' : '#374151')};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_TIGHT};
  text-align: center;
`

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 900px;
  height: 80vh;
  max-height: 700px;
  min-height: 600px;
  display: flex;
  flex-direction: column;export 
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid #e8e8e8;
  @media (max-width: 768px) {
    width: 100%;
    height: 90vh;
    max-height: none;
    border-radius: 6px;
  }
`

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  flex-shrink: 0;
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: ${TYPOGRAPHY.HEADING_M};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: #262626;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
  @media (max-width: 768px) {
    font-size: ${TYPOGRAPHY.HEADING_S};
  }
`

export const CloseButton = styled.button`
  background: white;
  border: 1px solid #d9d9d9;
  font-size: 16px;
  cursor: pointer;
  color: #8c8c8c;
  padding: 6px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  &:hover {
    background: #f5f5f5;
    border-color: #bfbfbf;
    color: #595959;
  }
`

export const ModalBody = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  min-height: 0;
`

export const Sidebar = styled.div`
  width: 200px;
  background: #fafafa;
  border-right: 1px solid #f0f0f0;
  overflow-y: auto;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 160px;
  }
  @media (max-width: 480px) {
    width: 140px;
  }
`
export const SidebarTab = styled.div`
  position: relative;
  padding: 16px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => (props.active ? '600' : '500')};
  color: ${props => (props.active ? '#262626' : '#8c8c8c')};
  background: ${props => (props.active ? 'white' : 'transparent')};
  border-radius: ${props => (props.active ? '6px 0 0 6px' : '0')};
  margin: ${props => (props.active ? '4px 0' : '4px 0')};
  transition: all 0.2s ease;
  line-height: 1.4;
  ${props =>
    props.active &&
    `
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border-right: 2px solid #444CE7; // Changed from #1890ff to #444CE7
  `}
  &:hover {
    background: ${props => (props.active ? 'white' : '#f5f5f5')};
    color: ${props => (props.active ? '#262626' : '#595959')};
  }
  ${props =>
    props.hasSelectedTopics &&
    !props.active &&
    `
    &::after {
      content: '${props.selectedCount}';
      position: absolute;
      top: 8px;
      right: 8px;
      width: 18px;
      height: 18px;
      background: #444CE7; // Changed from #1890ff to #444CE7
      color: white;
      border-radius: 50%;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
  ${props =>
    props.hasSelectedTopics &&
    props.active &&
    `
    &::after {
      content: '${props.selectedCount}';
      position: absolute;
      top: 8px;
      right: 6px;
      width: 20px;
      height: 20px;
      background: #444CE7; // Changed from #1890ff to #444CE7
      color: white;
      border-radius: 50%;
      font-size: 11px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
  
  @media (max-width: 768px) {
    padding: 14px 16px;
    font-size: 13px;
  }
`

export const MainContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  min-height: 0;
  background: #ffffff;
  @media (max-width: 768px) {
    padding: 20px;
  }
`

export const TopicsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

export const TopicItem = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 2px solid ${props => (props.isSelected ? '#444CE7' : '#f0f0f0')}; // Changed from #1890ff to #444CE7
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: ${TYPOGRAPHY.BODY_M};
  background: ${props => (props.isSelected ? '#eff6ff' : 'white')};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
  min-height: 50px;
  user-select: none;

  &:hover {
    border-color: ${props => (props.isSelected ? '#3730a3' : '#444CE7')};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: translateY(0);
  }

  input[type='checkbox'] {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #d9d9d9;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 5px;
      width: 4px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg) scale(0);
      transition: transform 0.2s ease;
    }

    &:checked {
      background: #444ce7;
      border-color: #444ce7;
      &::after {
        transform: rotate(45deg) scale(1);
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(68, 76, 231, 0.2);
    }
  }

  span {
    flex: 1;
    font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
    color: ${props => (props.isSelected ? '#3730a3' : '#595959')};
    transition: color 0.2s ease;
    cursor: pointer;
    font-size: ${TYPOGRAPHY.BODY_M};
    line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
  }
`

export const MinSelectionMessage = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: ${TYPOGRAPHY.BODY_M};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  display: flex;
  align-items: center;
  gap: 8px;
  animation: fadeIn 0.3s ease;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const CategoryHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start; // Changed from center to flex-start
`

export const CategoryLeftSection = styled.div`
  flex: 1;
`

export const CategoryTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`

export const CategoryRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CategoryCounter = styled.div`
  padding: 4px 12px;
  background: ${props => (props.count > 0 ? '#eff6ff' : '#f5f5f5')};
  border: 1px solid ${props => (props.count > 0 ? '#c7d2fe' : '#e0e0e0')};
  border-radius: 16px;
  font-size: ${TYPOGRAPHY.CAPTION};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: ${props => (props.count > 0 ? '#3730a3' : '#9e9e9e')};
  white-space: nowrap;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_TIGHT};
`

export const CategoryClearButton = styled.button`
  background: #fff5f5;
  border: 1px solid #fecaca;
  color: #dc2626;
  font-size: ${TYPOGRAPHY.CAPTION};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  &:hover {
    background: #fef2f2;
    border-color: #f87171;
  }

  &:disabled {
    background: #f9fafb;
    border-color: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
  }
`

export const SelectionCountText = styled.div`
  font-size: ${TYPOGRAPHY.BODY_M};
  color: #374151;
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const SelectionCount = styled.span`
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: ${props => (props.count < 15 ? '#444CE7' : '#444CE7')};
  font-size: ${TYPOGRAPHY.BODY_M};
`

export const SummaryText = styled.div`
  font-size: ${TYPOGRAPHY.BODY_M};
  color: #595959;
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  @media (max-width: 768px) {
    text-align: center;
  }
`

export const ClearAllButton = styled.button`
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #d9d9d9;
  color: #595959;
  font-size: ${TYPOGRAPHY.CAPTION};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  padding: 4px 16px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  &:hover {
    background: #f9fafb;
    border-color: #9ca3af;
  }
`

export const ContinueBtn = styled(Button)`
  background: linear-gradient(135deg, #444ce7 0%, #5b6aeb 100%);
  border: none;
  color: #ffffff;
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  height: 40px;
  padding: 0 32px;
  border-radius: 6px;
  font-size: ${TYPOGRAPHY.BODY_M};
  min-width: 140px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #5b6aeb 0%, #6366f1 100%);
    color: #ffffff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(68, 76, 231, 0.3);
  }

  &:focus:not(:disabled) {
    background: linear-gradient(135deg, #5b6aeb 0%, #6366f1 100%);
    color: #ffffff;
  }

  &:disabled {
    background: #f5f5f5;
    border: 1px solid #d9d9d9;
    color: #bfbfbf;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
  }
`

// Add these new styled components for consistent styling
export const SectionHeading = styled.h2`
  font-size: ${TYPOGRAPHY.HEADING_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: #1f2937;
  margin: 0 0 12px 0;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const SubsectionHeading = styled.h3`
  padding-left: 16px;
  padding-top: 12px;
  font-size: ${TYPOGRAPHY.HEADING_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: #374151;
  margin: 0 0 8px 0;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const BodyText = styled.div`
  padding-left: 16px;
  padding-bottom: 4px;
  font-size: ${TYPOGRAPHY.BODY_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  color: #374151;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_RELAXED};
  margin-bottom: 8px;
`

export const CaptionText = styled.div`
  font-size: ${TYPOGRAPHY.CAPTION};
  font-weight: ${TYPOGRAPHY.WEIGHT_REGULAR};
  color: #6b7280;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const SmallText = styled.div`
  font-size: ${TYPOGRAPHY.BODY_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_REGULAR};
  color: #6b7280;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const ConfigurationText = styled.div`
  font-size: ${TYPOGRAPHY.BODY_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  color: #374151;
  margin-bottom: 8px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  strong {
    font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  }
`

export const ValidationErrorText = styled.div`
  font-size: ${TYPOGRAPHY.BODY_M};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  color: #dc2626;
  padding: 12px 16px;
  background-color: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 6px;
  margin-bottom: 16px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const InfoBadge = styled.div`
  display: inline-flex;
  align-items: center;
  width: 450px;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 12px 65px;
  font-size: ${TYPOGRAPHY.BODY_M};
  font-weight: ${TYPOGRAPHY.WEIGHT_MEDIUM};
  color: #444ce7;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const CountBadge = styled.span`
  background-color: #0369a1;
  color: #ffffff;
  border-radius: 12px;
  padding: 4px 10px;
  margin-right: 12px;
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  font-size: ${TYPOGRAPHY.CAPTION};
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_TIGHT};
`

// Add these missing styled components to your assessmentstyles.js file:

export const CategoryTitle = styled.h3`
  font-size: ${TYPOGRAPHY.HEADING_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  color: #262626;
  margin: 0 0 8px 0;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};
`

export const ModalFooter = styled.div`
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  @media (max-width: 768px) {
    padding: 16px 20px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
`

export const FooterLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 200px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    margin-left: 0;
  }
`

export const FooterRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`

export const FooterSelectionSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Separator = styled.div`
  width: 96%;
  height: 1px;
  background-color: #e5e7eb;
  margin: 24px 0;

  @media (max-width: 768px) {
    margin: 16px 0;
  }
`

// Add these new styled components for Assessment Configuration section

export const AssessmentConfigContainer = styled.div`
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
`

export const ConfigurationItem = styled.div`
  margin-bottom: 12px;
`

export const ConfigurationNote = styled.div`
  font-size: ${TYPOGRAPHY.BODY_S};
  font-weight: ${TYPOGRAPHY.WEIGHT_REGULAR};
  color: #6b7280;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_RELAXED};
  font-style: italic;
  margin-bottom: 16px;
`

export const ConfigurationDetails = styled.details`
  margin-top: 8px;
`

export const ConfigurationSummary = styled.summary`
  font-size: ${TYPOGRAPHY.BODY_M};
  color: #374151;
  cursor: pointer;
  font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
  margin-bottom: 8px;
  user-select: none;

  &:hover {
    color: #1f2937;
  }
`

export const ConfigurationDetailsContent = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
`

export const ConfigurationDetailItem = styled.div`
  font-size: ${TYPOGRAPHY.BODY_S};
  color: #6b7280;
  margin-bottom: 4px;
  line-height: ${TYPOGRAPHY.LINE_HEIGHT_NORMAL};

  strong {
    font-weight: ${TYPOGRAPHY.WEIGHT_SEMIBOLD};
    color: #374151;
  }

  &:last-child {
    margin-bottom: 8px;
  }
`

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  max-width: 100%;  // ← Changed from 1400px to 100%
  margin: 0 auto;
`;

export const LeftContent = styled.div`
  flex: 1;
  flex-shrink: 0;
  max-width: 100%;  // ← Changed from 463px to 100% (this is the key fix!)
`;

export const RightSidebar = styled.div`
  width: 320px;
  flex-shrink: 0;
`;

export const InfoCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 400;
  color: #111827;
  margin-bottom: 15px;
  text-align: center;
`;

export const CardSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
  text-align: center;
`;

export const SectionButton = styled.button`
  width: 100%;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    background: #e5e7eb;
  }

  &.expanded {
    background: #EDEBF8;
    // border-color: #a78bfa;
    color: #111827;
  }
`;

export const SectionContent = styled.div`
  // background: #f9fafb;
  // border: 1px solid #e5e7eb;
  // border-radius: 8px;
  padding: 16px;
  // margin-bottom: 16px;
`;

export const DetailItem = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
`;

export const DetailValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

